export default "__VITE_ASSET__6b77248e__"